import { IValidationRule } from "@/types"

const financialFactorsValidationRules: { [s: string]: IValidationRule } = {
    minimumDepreciationPeriod: {
        required: true,
        type: "integer",
        min: 1,
        max: 99,
    },
    imputedInterestRate: {
        required: true,
        type: "decimal",
        min: 0,
        max: 100,
    },
    startDepreciationUsing: {
        required: true,
    },
    localCalculationRule: {
        required: true,
    },
    constructionMonth: {
        required: true
    }
}

export default financialFactorsValidationRules
